module.exports = __webpack_public_path__ + "static/media/math-card-side.fa8dab3c.png";